
















































































































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as weixin from '@ivy/fts/weixin'
import { uploadEvent } from '@/api/goods/statistics'
const convertPxToVw = pixel => {
  const viewportWidth = 375
  return (100 / viewportWidth) * parseInt(pixel)
}

const px2RealPx = (px, sW) => {
  let k = (sW / 750) * px
  return k
}

@Component({})
export default class KetLine extends Vue {
  showTest: boolean = false
  hasLevel: string = ''
  activeKey: string = 'Zero Based'
  activeIndex: number = 0
  firstKey: string = 'Zero Based'
  lastKey: string = 'B1'
  screenX: number = 0
  isMove: boolean = false
  data: any = {}
  levels: any = []
  goodsKey: number = 0

  contentWidth: number = window.screen.width

  // goods: any = [
  //   {
  //     id: '1',
  //     title: '备考教程',
  //     good: [
  //       {
  //         id: '1',
  //         title: 'Power Up Level 3',
  //         desc: '剑桥大学出版社&剑桥考评部合作推出的官方',
  //         type: 'KET 考试',
  //       },
  //       {
  //         id: '2',
  //         title: 'Power Up Level 4',
  //         desc: '剑桥大学出版社&剑桥考评部合作推出的官方',
  //         type: 'KET 考试',
  //       },
  //     ],
  //   },
  // ]

  get getLevelName() {
    return (this.levels.find(item => item.level === this.data.userLevel) || {})
      .name
  }

  get getColor() {
    return {
      color:
        (this.levels.find(item => item.level === this.data.userLevel) || {})
          .color || '',
    }
  }
  get goodsInfo() {
    return {
      goodsKey: this.activeKey,
      goods:
        (this.levels.find(item => item.level === this.activeKey) || {})
          .floors || [],
    }
  }
  get getLineBox() {
    let w = this.contentWidth
    let itemWidth = (w - px2RealPx(60, this.contentWidth)) / 4

    return {
      width: px2RealPx(80, this.contentWidth) + itemWidth * 9 + 'px',
    }
    // let itemEl = document.querySelector('.level-box .item')
    // let screenWidth = window.screen.width
    // if (itemEl) {
    //   let itemWidth = itemEl.clientWidth
    //   console.log('first', screenWidth, itemWidth)
    //   return {
    //     width: itemWidth * 8 + 120 + 'px',
    //   }
    // } else {
    //   console.log('first2', screenWidth)
    //   return {
    //     width: screenWidth * 2 + 30 + 'px',
    //   }
    // }
  }
  get getBodyBox() {
    let screenWidth = this.contentWidth
    let mr =
      px2RealPx(20, this.contentWidth) * 6 + px2RealPx(60, this.contentWidth)
    return {
      width: screenWidth * 6 + 'px',
    }
  }
  get getStyle() {
    return index => {
      let w = this.contentWidth
      // let itemWidth = px2RealPx(200)
      // let contentW = w - 60

      // let selfW = contentW / 4
      // let baseLeft = w / 2 - itemWidth / 2
      // return {
      //   left: baseLeft + selfW * index + 'px',
      // }
      let itemWidth = (w - px2RealPx(60, this.contentWidth)) / 4
      return {
        // left: (w - px2RealPx(200)) / 2 + 'px',
        left:
          px2RealPx(30, this.contentWidth) +
          itemWidth * 2 -
          px2RealPx(100, this.contentWidth) +
          itemWidth * index +
          'px',
      }
    }
  }
  get getItemStyle() {
    return item => {
      let k = px2RealPx(60, this.contentWidth)
      let width = this.contentWidth - k * 2 + 'px'
      return {
        background: item.color,
        width: width,
      }
    }
  }

  async created() {
    await env.init()
    this.loadInfo()
    await uploadEvent.init()
    uploadEvent.addStatistics({
      event_type: 'Exposure_KETRoadmap',
    })
  }
  mounted() {
    this.contentWidth = Math.min(
      (document.querySelector('.ket-line-page') as any).offsetWidth ||
        window.screen.width,
      window.screen.width
    )
    this.initDisplayEvent()
    this.bindEvent()
  }
  // 需求: 兼容静默加载，页面显示时才曝光
  initDisplayEvent() {
    if (env.type === 'ivydad') {
      document.addEventListener('visibilitychange', this.pageVisible)
    }
  }
  pageVisible() {
    if (!document.hidden) {
      this.loadInfo()
    }
  }
  destroyed() {
    if (env.type === 'ivydad') {
      delete window['_isDisplayingOnScreen']
    }
  }
  async loadInfo() {
    let { data } = await this.$axios.get('/api/mobile/app/road_map/ket')

    this.levels = data.level_group || []
    this.showTest = !!data.show_test_button
    this.hasLevel = data.userLevel
    this.activeKey = data.userLevel || 'Zero Based'
    let item =
      data.level_group.find(item => item.level === data.userLevel) ||
      data.level_group[0]
    let index = Math.max(
      data.level_group.findIndex(item => item.level === data.userLevel),
      0
    )

    this.data = data
    this.setShare(data.share_data)
    await this.$nextTick()
    this.goItem(item, index)
  }
  async setShare(config) {
    if (env.type === 'ivydad') {
      await env.init()
      await env.shareInfo(config)
    } else {
      await weixin.weixinShare({
        title: config.title,
        desc: config.content,
        imgUrl: config.pic_url,
        link: config.url,
      })
    }
  }
  bindEvent() {
    let moveWrap = document.querySelector('.level-wrap')
    if (env.type !== 'ivydad') {
      moveWrap.addEventListener('touchstart', this.touchstart)
      moveWrap.addEventListener('touchmove', this.touchmove)
      moveWrap.addEventListener('touchend', this.touchend)
    }
  }
  touchstart(e) {
    let touch = e.changedTouches[0]
    this.screenX = touch.clientX
  }
  touchmove() {
    this.isMove = true
  }
  touchend(e) {
    let touch = e.changedTouches[0]
    let endClientX = touch.clientX

    if (this.isMove) {
      let isLeft = endClientX - this.screenX > 5

      if (isLeft) {
        if (this.activeKey === this.firstKey) {
          return
        } else {
          this.activeIndex--
        }
      } else {
        if (this.activeKey === this.lastKey) {
          return
        } else {
          this.activeIndex++
        }
      }
      this.doMove(this.activeIndex)
      this.activeKey = this.levels[this.activeIndex]['level']
    }
    this.isMove = false
    this.screenX = 0
  }
  removeEvent() {
    let moveWrap = document.querySelector('.level-wrap')
    moveWrap.removeEventListener('touchmove', this.touchmove)
    moveWrap.removeEventListener('touchend', this.touchend)
  }
  goItem(item, index) {
    this.doMove(index)
    this.activeIndex = index
    this.activeKey = item.level
  }
  async doMove(index) {
    let levelEl = document.querySelector('.level-box') as any
    let contentEl = document.querySelector('.body-box') as any
    let width = (this.contentWidth - px2RealPx(60, this.contentWidth)) / 4
    levelEl['style'].transform = `translate3d(${-width * index}px, 0, 0)`

    let k = px2RealPx(60, this.contentWidth)
    let k2 = px2RealPx(20, this.contentWidth)
    let screenWidth = this.contentWidth - k * 2 + k2
    contentEl['style'].transform = `translate3d(${'-' +
      screenWidth * index}px, 0, 0)`

    // await this.$nextTick()
    // let mainEl = document.querySelector('.main-container')
    // if (mainEl) {
    //   mainEl.scrollTop = 468
    // }
  }
  async goTest() {
    try {
      await uploadEvent.addStatistics({
        event_type: 'Click_KETRoadmap_TestButton',
      })
    } catch (e) {
      console.error(e)
    }

    await env.init()
    if (env.type === 'ivydad') {
      let url = `${window.location.origin}/goods/ket-test`
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      this.$router.push({
        path: 'ket-test',
      })
    }
  }
  async goCourse(item) {
    let nameMap = {
      c_course: '互动课程',
      k_course: '专栏课程',
      goods: '商品SKU',
      h5: 'h5',
    }
    try {
      await uploadEvent.addStatistics({
        event_type: 'Click_KETRoadmap_Content',
        p1: item.resource_id,
        p2: item.title,
        p3: nameMap[item.resource_type] || '',
      })
    } catch (e) {
      console.error(e)
    }

    let url = `${window.location.origin}/age3?courseId=${item.resource_id}`
    if (item.resource_type === 'k_course') {
      url = `${window.location.origin}/knowlege/channelDetail?id=${item.resource_id}`
    } else if (item.resource_type === 'goods') {
      url = `${window.location.origin}/goods/goodsView?spuId=${item.spu_id}&selectSkuId=${item.resource_id}&navbarHide=1`
    } else if (item.resource_type === 'h5') {
      url = item.url
    }

    if (env.type === 'ivydad') {
      await env.init()
      if (item.resource_type === 'goods') {
        env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
      } else if (item.resource_type === 'k_course') {
        env.commonJump(
          `ivydadreadtool://detail/course/kCourse?id=${item.resource_id}`
        )
      } else if (item.resource_type === 'c_course') {
        env.commonJump(
          `ivydadreadtool://detail/course/cCourse?id=${item.resource_id}`
        )
      } else if (item.resource_type === 'h5') {
        env.commonJump(
          `ivydadreadtool://h5?url=${encodeURIComponent(item.url)}`
        )
      }
    } else {
      window.location.href = url
    }
  }
}
